module.exports = __webpack_public_path__ + "img/35ne.f84e887d.svg";